import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './sessionMovements.html'

/**
 * SessionMovements Report route
 *
 * @namespace routes.ReportSessionMovements
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.sessionMovements.list',
  label: 'REPORT.SESSIONMOVEMENTS.TITLE',
  url: '/sessionMovements',
  component: 'tmrReportSessionMovements',
  resourceType: 'SessionMovement',
  resourceList: {
    searchParameters: [
      'code',
      'creationDate',
      'sessionMovementType',
      'createdBy.id',
      'session.id',
    ],
  },
  accessControl: ['Resource.list', 'Resource.SessionMovement.list'],
}

/**
 * Component for {@link routes.tmrReportSessionMovements SessionMovements Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportSessionMovements = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
}
